export default function openColorTool() {
	const colors = document
		.getElementsByClassName('selected-colors-list')[0]
		.getElementsByClassName('color');

	if (/^background: url/.test(colors[0].getAttribute('style'))) {
		colors[0].click();
	} else colors[1].click();
}
